<template>
  <div>
    <scroll-to-top />
    <footer>
      <TopFooter />
      <BottomFooter />
    </footer>
  </div>
</template>

<script>
import ScrollToTop from "../static/scrollToTop.vue";
import BottomFooter from "./navigation-options/bottomFooter.vue";
import TopFooter from "./navigation-options/topFooter.vue";

export default {
  components: {
    TopFooter,
    BottomFooter,
    ScrollToTop,
  },
};
</script>
